import GeoProvider from './geoProvider'

export default function (ctx) {
    const { nuxtState } = ctx

    return new GeoProvider(ctx, nuxtState.$geolocation)
}
